exports = module.exports = require("../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error403-wrapper{position:fixed;width:100%;min-height:100%;text-align:center;font-size:0;line-height:1;background:#1b1a20 url(" + require("./404.png") + ") no-repeat top}.error403-wrapper ul{margin-top:620px}.error403-wrapper ul li{font-size:20px;display:inline-block;vertical-align:top;width:190px;height:50px;line-height:50px;cursor:pointer;border-radius:25px;margin-right:45px}.error403-wrapper ul li:first-child{border:1px solid #1093d0;color:#1093d0}.error403-wrapper ul li:first-child a{color:#1093d0}.error403-wrapper ul li:first-child:hover{background:#1093d0}.error403-wrapper ul li:first-child:hover a{color:#fff}.error403-wrapper ul li:last-child{color:#161616;margin-right:0;border:1px solid #ff7e00;background:#ff7e00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-1c726112","scoped":false,"hasInlineConfig":false}!./~/_stylus-loader@3.0.2@stylus-loader!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/components/notFound/notFound.vue
// module id = 757
// module chunks = 9